module.exports = __webpack_public_path__ + "img/bg2.3367c921.jpg";